//@ts-nocheck
export const dateFormatter = function (inputDate : any, offset = { days: 0, months: 0, years: 0 }, format : any = 'yyyy-mm-dd') {
    const retDate = new Date(inputDate);
    retDate.setFullYear(retDate.getFullYear() + (offset.years || 0));
    retDate.setMonth(retDate.getMonth() + (offset.months || 0));
    retDate.setDate(retDate.getDate() + (offset.days || 0));     
    const year = retDate.getFullYear();
    const month = String(retDate.getMonth() + 1).padStart(2, '0');
    const day = String(retDate.getDate()).padStart(2, '0');
    return format.replace('yyyy', year).replace('mm', month).replace('dd', day); 
};
export const daysDifference = function (firstDay: Date, secondDay: Date) {
    const oneDay = 24 * 60 * 60 * 1000; 
    firstDay.setHours(0, 0, 0, 0);
    const diffDays = Math.round((secondDay- firstDay) / oneDay);
    return diffDays;
  }